// src/services/patientDashboard.js

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:8001";

const API_BASE = `${BACKEND_URL.replace(/\/$/, "")}/api/v1`;

function getAuthSession() {
  try {
    const raw = localStorage.getItem("orbismed_patient_auth");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function getPatientToken() {
  return getAuthSession()?.access_token || null;
}

async function request(path, options = {}) {
  const token = getPatientToken();

  const headers = {
    ...(options.headers || {}),
  };

  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = headers["Content-Type"] || "application/json";
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    let message = "Request failed";

    try {
      const data = await response.json();
      message = data.detail || data.message || message;
    } catch {
      try {
        message = await response.text();
      } catch {
        message = response.statusText || message;
      }
    }

    throw new Error(message);
  }

  if (response.status === 204) return null;

  return response.json();
}

export const patientDashboardApi = {
  summary(options = {}) {
    return request("/patients/me/dashboard", { signal: options.signal });
  },
};
